import { Button, Modal, Result } from "antd";
import { useNavigate } from "react-router-dom";

type alertType = "success" | "info" | "warning" | "error";

export const SuccessModal = ({
  title,
  message,
  type,
  buttonText,
  redirect,
  open,
  setOpen,
  reTrigger,
}: {
  title?: string;
  message: string;
  type: alertType;
  buttonText: string;
  redirect: any;
  reTrigger?: any;
  open: any;
  setOpen: any;
}) => {
  const navigate = useNavigate();
  return (
    <Modal
      open={open}
      footer={null}
      centered
      width={500}
      onCancel={() => {
        setOpen(false);
        if (reTrigger) {
          reTrigger(true);
        }
        if (redirect != "") {
          navigate(redirect);
        }
      }}
    >
      <Result
        status={type}
        title={title}
        subTitle={message}
        extra={[
          <Button
            type="primary"
            onClick={() => {
              setOpen(false);
              if (reTrigger) {
                reTrigger(true);
              }
              if (redirect != "") {
                navigate(redirect);
              }
            }}
          >
            {buttonText}
          </Button>,
        ]}
      />
    </Modal>
  );
};
